import { useMemo } from 'react';

import type { GridInitialState } from '@mui/x-data-grid';

import { buildAscendingSorting } from '../../../../../components/DataGrid/utils/build-ascending-sorting.util';
import { useReferencesContext } from '../../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { COST_STATUS_ID } from '../get-columns';

export const useInitialGridState = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  const initialGridState = useMemo<GridInitialState>(
    () => ({
      sorting: buildAscendingSorting('costCode'),
      columns: {
        columnVisibilityModel: {
          [COST_STATUS_ID]: false,
        },
      },
      filter: {
        filterModel: {
          items: [
            {
              field: COST_STATUS_ID,
              operator: 'is',
              value: genericStatusesCodeMap.Enabled.code,
            },
          ],
        },
      },
    }),
    [genericStatusesCodeMap.Enabled.code],
  );

  return { initialGridState };
};
